import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { notificationfeatureName, reducerNotification, NotificationsEffects } from './store';
import { EffectsModule } from '@ngrx/effects';
import { SignalMessageService } from '@app/common/services/signalmessage.service';


@NgModule({
  providers: [SignalMessageService],
    imports: [
        StoreModule.forFeature(notificationfeatureName, reducerNotification),
        EffectsModule.forFeature([ NotificationsEffects ])
    ]
})
export class NotificationsStateModule { }
